// extracted by mini-css-extract-plugin
module.exports = {"audio":"styles_audio__3eZjB"};